var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-bg-contractor text-white px-3 rounded text-white mx-2 leading-relaxed whitespace-no-wrap"},[_vm._v(" "+_vm._s(_vm.contractor.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }